// Angular
import { Component } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Output, EventEmitter } from '@angular/core'; 

// Rxjs
import { takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
 

// Models
import { IntakeStepModel } from 'app/_models/intakestep.model';

// Store
import { Select } from '@ngxs/store';
import { IntakeState } from 'app/_state/intake.state';

// 3rd Party
import * as _ from 'underscore';

import {
    faArrowLeft,
    faPlaneDeparture,
    faUsers,
    faUserInjured,
    faClipboardCheck,
    faList,
    faFolderOpen,
    faCheckSquare,
    faHospital,
    faMapMarkerAlt,
    faHospitalUser,
    faNotesMedical,
    faStethoscope,
    faFileInvoiceDollar
} from "@fortawesome/free-solid-svg-icons";
import { Router } from '@angular/router';

@Component({
    selector: 'intake-title-icon',
    templateUrl: 'intake-title-icon.component.html',
    styleUrls: ['./intake-title-icon.component.scss'],
    providers: [
    ]
})

export class IntakeTitleIconComponent implements OnInit, OnDestroy {
    @Output() change: EventEmitter<any> = new EventEmitter<any>();
    @Select(IntakeState.getSteps) stepsData$: Observable<[]>;

    steps: IntakeStepModel[] = [];
    private subject$ = new Subject();
    public activeStepData = {};

    arrowBack = faArrowLeft;
    faClipboardCheck = faClipboardCheck;
    UserInjured = faUserInjured;
    faHospital = faHospital;
    faNotesMedical = faNotesMedical;
    faStethoscope = faStethoscope;
    faHospitalUser = faHospitalUser;
    faMapMarkerAlt = faMapMarkerAlt;
    faPlaneDeparture = faPlaneDeparture;
    faUsers = faUsers;
    faList = faList;
    faFolderOpen = faFolderOpen;
    faCheckSquare = faCheckSquare;
    faFileInvoiceDollar = faFileInvoiceDollar;

    constructor( 
        private router: Router,
    ) {
    }

    private getSteps(): void {
        this.stepsData$
            .pipe(takeUntil(this.subject$))
            .subscribe((res) => {
                this.steps = res;

                const currentPath = this.router.url;
                const filterPath = "/dashboard/home/intake/";
                const currentStep = currentPath.replace(filterPath, '');
                const lastActiveStep = this.steps.filter((s) => s.url == currentStep);

                if (lastActiveStep && lastActiveStep.length > 0) {
                    this.activeStepData = lastActiveStep[0];
                }
            });
    }

    public geticon(): string {
        return this[this.activeStepData['icon']];
    }

    

    ngOnInit() {
        this.getSteps();
    }

    ngOnDestroy() { 

        this.subject$.next();
        this.subject$.complete();
    }
 
}
